import { TagItem } from './../../../components/Tags/types'

export const defaultItem: TagItem = {
  type: '',
  text: '',
  value: ''
}

// TODO: Type state
export const state = {
  tag: {},
  tags: [],
  group: {},
  groups: [],
  dialog: {
    active: false,
    action: 'create',
    type: 'Group', // :: Group || Description
    title: '',
    label: '',
    item: defaultItem,
    items: [] as any[],
    selected: [] as any[]
  },
  error: {
    show: false,
    type: 'success',
    message: ''
  }
}

export type State = typeof state
